import AcousticIcon from 'assets/observationTypeDefaults/acoustic-icon.png'
import IRIcon from 'assets/observationTypeDefaults/ir-icon.png'
import OilIcon from 'assets/observationTypeDefaults/oil-icon.png'
import ThermalIcon from 'assets/observationTypeDefaults/thermal-icon.png'
import VibrationIcon from 'assets/observationTypeDefaults/vibe-icon.png'
import VisualIcon from 'assets/observationTypeDefaults/visual-icon.png'
import React from 'react'
import styled from 'styled-components'
import { GeckoSiteObservation } from 'types'

const DefaultImageContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`

const DefaultImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

interface DefaultObservationImageProps {
  observation: GeckoSiteObservation
  style?: React.CSSProperties
}

export const DefaultObservationImage: React.FC<
  DefaultObservationImageProps
> = ({ observation, style }) => {
  let defaultImagePath: string | undefined

  const type = observation.data.type?.toLowerCase() || ''

  if (type.includes('acoustic')) {
    defaultImagePath = AcousticIcon
  } else if (type.includes('oil')) {
    defaultImagePath = OilIcon
  } else if (type.includes('visual') || type.includes('vis')) {
    defaultImagePath = VisualIcon
  } else if (type.includes('vib') || type.includes('vibe')) {
    defaultImagePath = VibrationIcon
  } else if (type.includes('thermal')) {
    defaultImagePath = ThermalIcon
  } else if (type.includes('infrared') || type.includes('ir')) {
    defaultImagePath = IRIcon
  }

  return (
    <DefaultImageContainer style={style}>
      <DefaultImage src={defaultImagePath} />
    </DefaultImageContainer>
  )
}
